import React from 'react';
import { Link } from 'react-router-dom';
import viewUtil from '../lib/viewUtil';

import './PlayerList.css';

class PlayerList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            playerList: this.props.playerData
        }

        this.handleSearch = this.handleSearch.bind(this);
    }

    handleSearch(e) {
        let searchingFor = e.target.value,
            filteredPlayerList = this.props.playerData;
        
        if (searchingFor.length > 0) {
            filteredPlayerList = this.props.playerData.filter(player => {
                searchingFor = searchingFor.toUpperCase();
                return player.name.toUpperCase().indexOf(searchingFor) > -1 || 
                (typeof player.manager === 'string' && player.manager.toUpperCase().indexOf(searchingFor) > -1) ||
                player.contract?.toString() === searchingFor;
            });
        }

        this.setState({
            playerList: filteredPlayerList
        });
    }

    render() {
        return (
            <div id="playerListContainer">
                <h2>Player List</h2>
                <div className="playerListSearchContainer">
                    <small id="searchDetails" className="form-text text-muted">Filter by player or team name, or contract years</small>
                    <form className="form-inline">
                        <input className="form-control" type="search" placeholder="Search" aria-label="Search" onChange={this.handleSearch}></input>
                    </form>
                </div>
                <table className="table table-dark table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Rank | Name | Pos</th>
                            <th scope="col">Age</th>
                            <th scope="col" style={{textAlign: "right"}}>Team | Deal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.playerList.map((player, index) => {
                            return (
                                <tr key={player + index}>
                                    <td><span className="fst-italic">{player.yahooleaguerank || '-'}</span> <Link to={`/player/${player.id}`}>{player.name}</Link>
                                    &nbsp;<span className="fst-italic">{player.posname}</span> <span>{player.nflteam}</span>
                                    </td>
                                    <td>{viewUtil.getAge(player.birthdate) ?? '--'}</td>
                                    <td style={{textAlign: "right"}}><span>{player.manager && player.manager !== 'null' ? player.manager + ' | ' + (player.franchisetag ? 'FT - ' + player.franchisetag : player.contract || 0) : ''}</span></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PlayerList;